import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Phase 5 §13.2 — feeds the SAME ErrorEvent/trend-detection pipeline as
// backend errors. Fire-and-forget: never throws, never blocks the caller.
export async function reportClientError(errorType, message, stack) {
  try {
    await axios.post(`${BACKEND_URL}/api/support/client-errors`, {
      error_type: errorType,
      message: String(message || '').slice(0, 1000),
      stack: stack ? String(stack).slice(0, 1000) : undefined,
      page: window.location.pathname,
      app_version: process.env.REACT_APP_VERSION,
    });
  } catch (e) {
    // never block the UI on a reporting failure
  }
}
